import React, { useState } from "react";
import PillButton from "../../components";
import { InputField } from "../../components/input/Input";

const SuggestionForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    recommend: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formDataValues = new FormData(e.target as HTMLFormElement); // Retrieves all form inputs

    const formData = new FormData();
    formData.append("fullName", formDataValues.get("fullName") ?? "");
    formData.append(
      "email",
      formDataValues.get("email") || "kontakt@fahrschul-kurse.ch"
    );
    formData.append("phone", formDataValues.get("phone") || "");
    formData.append("recommend", formDataValues.get("recommend") ?? "");

    try {
      // Send the POST request to the PHP backend
      const response = await fetch(
        "https://www.fahrschul-kurse.ch/emailservice/sendEmailSuggestion.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("E-Mail erfolgreich gesendet!");
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("E-Mail konnte nicht gesendet werden.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-4xl mx-auto ">
      <div className="grid grid-cols-2 gap-20 p-6 max-md:grid-cols-1 max-md:gap-0">
        <div>
          {/* First and Last Name */}
          <InputField
            label="Vorname und Nachname"
            type="text"
            name="fullName"
            placeholder="Geben Sie Ihren vollständigen Namen ein"
            value={formData.fullName}
            onChange={handleChange}
          />

          {/* Cell Phone */}
          <InputField
            label="Handynummer"
            type="tel"
            name="phone"
            placeholder="Geben Sie Ihre Telefonnummer ein"
            value={formData.phone}
            onChange={handleChange}
          />

          {/* Email */}
          <InputField
            label="e-mail"
            type="email"
            name="email"
            placeholder="Geben Sie Ihre E-Mail-Adresse ein"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        {/* News */}
        <div>
          <InputField
            label="Fragen"
            type="text"
            name="recommend"
            isTextarea={true}
            placeholder="Geben Sie einen Vorschlag oder eine Anfrage ein"
            // placeholder="Give suggestion or inquiry..."
            value={formData.recommend}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Submit Button */}
      <div className="col-span-1 md:col-span-2 flex justify-start ml-6">
        <button type="submit">
          <PillButton text={"Frage senden"} />
        </button>
      </div>
    </form>
  );
};

export default SuggestionForm;
